import { useEffect, useState } from 'react'

interface ServiceEventsList {
  requestIds: string[]
  requests: Record<string, string[]>
}

export default function useServiceEvents(serviceType: string | undefined) {
  const [serviceEventsList, setServiceEventsList] =
    useState<ServiceEventsList | null>(null)
  const [error, setError] = useState()

  useEffect(
    function loadServiceEvents() {
      if (serviceType) {
        import(`./EventsData/${serviceType}.json`)
          .then((jsonModule) => setServiceEventsList(jsonModule.default))
          .catch((importError) => {
            setError(importError)
            setServiceEventsList(null)
            console.log('Error importing service events list', importError)
          })
      }
    },
    [serviceType]
  )

  return { serviceEventsList, setServiceEventsList, error }
}
